<div class="modal-body width-600">
  <span class="modal-header">
    {{
      !receipt.rcptStatement ?
          getResource('HeaderNewMode')
          : getResource('HeaderNewModeStatement')

	  }}
  </span>
	<div class="app-layout-upload-1-auto">
		<ng-container *ngIf="receipt.rcptStatement">
			<exg-textarea [caption]="enumSvc.getFieldCaption('Receipt', 'rcptStatementReason')"
			              [(ngModel)]="receipt.rcptStatementReason">
			</exg-textarea>
		</ng-container>
		<ng-container *ngIf="!skipFileUpload">
			<div class="content">
				<div class="list height-700"
				     cdkDropList
				     cdkDropListOrientation="vertical"
				     (cdkDropListDropped)="onFileDrop($event)">
					<ng-container *ngFor="let selectedFile of selectedFiles; index as i">
						<div class="list-row  list-single-line list-row-auto-1-auto typo-small"
						     cdkDrag
						     *ngIf="selectedFile && selectedFile.dokMIME">
							<div class="list-icon">
								<i class="fal" flow="right"
								   [tooltip]="!isValidPDF(selectedFile.dokMIME) ? getRessource('NoSupported') : selectedFile.dokMIME.toUpperCase()"
								   [class.c-red]="!isValidPDF(selectedFile.dokMIME)"
								   [class.fa-file-pdf]="selectedFile.dokMIME.toUpperCase() === 'PDF'"
								   [class.fa-file-excel]="selectedFile.dokMIME.toUpperCase() === 'XLSX'"
								   [class.fa-file-word]="selectedFile.dokMIME.toUpperCase() === 'DOCX'"
								   [class.fa-file-image]="selectedFile.dokMIME.toUpperCase() === 'JPEG' || selectedFile.dokMIME.toUpperCase() === 'PNG'"
								   [class.fa-exclamation-triangle]="!isValidPDF(selectedFile.dokMIME)">
								</i>
							</div>
							<span class="list-primary-text" [class.c-red]="!isValidPDF(selectedFile.dokMIME)">
                {{
                  (i+1) + '.: ' + getResource('File', {
                      Filename: selectedFile.dokName,
                      Filesize: appSvc.file.calcFileSize(selectedFile.dokGroesse, false)
                  }) + ' '
								}}
<!-- 								+ (!proofFileSize(selectedFile.dokGroesse) ? ' - ' + getRessource('NoSupported') : '') -->
              </span>
							<div class="">
								<i class="fal fa-arrow-up search-filter-action"
								   (click)="move(i, -1)"
								   [class.disabled]="i === 0"></i>
								<i class="fal fa-arrow-down search-filter-action"
								   (click)="move(i, 1)"
								   [class.disabled]="i === selectedFiles.length - 1"></i>
								<i (click)="delete(selectedFile)"
								   [class.c-red]="!isValidPDF(selectedFile.dokMIME)"
								   [class.fa-trash]="isValidPDF(selectedFile.dokMIME)"
								   [class.fa-times]="!isValidPDF(selectedFile.dokMIME)"
								   class="fa-light search-filter-action">
								</i>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</ng-container>
	</div>
	<div class="spawn-modal-actions">
		<button (click)="close()" class="md-btn">
			{{getGlobal('Cancel')}}
		</button>
		<button (click)="upload()"
		        [disabled]="getFiles().length === 0"
		        class="md-btn">
			{{getGlobal('Create')}}
		</button>
	</div>
</div>
